import {useGetCustomer, useGetCustomerActivities} from '@/modules/customers/api'
import {Customer, EventLog} from '@cypro/engine/schema'
import {createContext, PropsWithChildren, useContext} from 'react'

interface State {
  customer: Customer
  activities: EventLog[] | undefined
}

interface Props extends PropsWithChildren {
  customer: Customer
}

const CustomerContext = createContext<State>({} as State)

export function CustomerProvider({children, customer: initialCustomer}: Props) {
  const [customer] = useGetCustomer(initialCustomer?.id)
  const [activities] = useGetCustomerActivities(initialCustomer?.id)

  return (
    <CustomerContext.Provider value={{customer: customer || initialCustomer, activities}}>
      {children}
    </CustomerContext.Provider>
  )
}

export function useCustomerContext() {
  return useContext(CustomerContext)
}
